import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MovdNotice from '../design-system/MovdNotice.jsx';
import MovdButton from '../design-system/MovdButton.jsx';
import { movdTokens } from '../design-system/movdTokens.js';

const copy = {
  messages: {
    title: 'Your messages',
    body: 'Open your current move workspace to message your mover. Conversations stay attached to the booking so the right people always have the right context.',
    action: 'Open current move',
  },
  settings: {
    title: 'Account settings',
    body: 'Your customer account is active. Password, email verification, and profile controls are being organized here as part of the MOVD portal.',
    action: 'Return to current move',
  },
};

export default function CustomerPortalSection() {
  const navigate = useNavigate();
  const { section } = useParams();
  const content = copy[section] || copy.messages;
  return (
    <div style={{ maxWidth: 860, margin: '0 auto', padding: 'clamp(24px, 5vw, 56px) 20px' }}>
      <button type="button" onClick={() => navigate('/customer-portal')} style={{ background: 'transparent', border: 'none', color: movdTokens.color.content.secondary, fontWeight: 700, cursor: 'pointer', marginBottom: 16, padding: 0 }}>‹ Current move</button>
      <div style={{ padding: 'clamp(20px, 4vw, 40px)', border: '1px solid #D9E2EC', borderRadius: 12, background: '#fff' }}>
        <p style={{ margin: 0, color: movdTokens.color.action.primary, fontWeight: 800, letterSpacing: '.1em', fontSize: 11, textTransform: 'uppercase' }}>Customer portal</p>
        <h1 style={{ margin: '8px 0 0', fontSize: 28, fontWeight: 900 }}>{content.title}</h1>
        <MovdNotice tone="info" style={{ marginTop: 20 }}>{content.body}</MovdNotice>
        <MovdButton onClick={() => navigate('/customer-portal')} style={{ marginTop: 20 }}>{content.action}</MovdButton>
      </div>
    </div>
  );
}
